import React, { FC } from 'react';
import './OnboardNewClientPromptStep.scss';
import { Button } from 'src/screens/OnboardingTrainer/components/Button/Button';
import { ReactComponent as NextIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/next.svg';

interface OnboardNewClientPromptStepProps {
  onNext?: () => void;
  onLater?: () => void;
}

export const OnboardNewClientPromptStep: FC<OnboardNewClientPromptStepProps> = ({
  onNext,
  onLater,
}) => {
  return (
    <div className="onboard-new-client-prompt-step">
      <h2 className="step-title">Would you like to onboard you new client now?</h2>
      <p className="step-subtitle">You&apos;ll have to answer some questions about this client.</p>

      <div className="prompt-actions">
        <Button
          variant="primary"
          className="btn-primary-white m-height-48 right-arrow prompt-btn"
          onClick={onNext}
          svg={<NextIcon />}
        >
          <span className="btn-text">Onboard Client</span>
        </Button>

        <button className="prompt-btn-later" onClick={onLater}>
          I&apos;ll do it later
        </button>
      </div>
    </div>
  );
};
